export default __webpack_public_path__ + "static/media/digest-flow-scratch.31536f39.svg";